import { LoginForm, LoginRequest } from "@/ServerTypes/Membership";
import { Texts } from "@/ServerTypes/Texts";
import { PropertyPanel } from "@serenity-is/corelib";
import { ErrorHandling, htmlEncode, isEmptyOrNull, notifyError, parseQueryString, resolveUrl, serviceCall, ServiceResponse, localText } from "@serenity-is/corelib/q";
import { PromptDialog } from "@serenity-is/extensions";

$(function () {
    var loginPanel = new LoginPanel($('#LoginPanel')).init();
    loginPanel.element.find('.forgot-password').appendTo('.field.Password');

    if ((document.getElementById('IsPublicDemo') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val('admin').attr('placeholder', 'admin')
        loginPanel["byId"]('Password').val('serenity').attr('placeholder', 'serenity');
    }

    if ((document.getElementById('Activated') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val((document.getElementById('Activated') as HTMLInputElement)?.value);
        loginPanel["byId"]('Password').focus();
    }
});

class LoginPanel extends PropertyPanel<LoginRequest, any> {

    protected getFormKey() { return LoginForm.formKey; }

    constructor(container: JQuery) {
        super(container);

        this.byId('LoginButton').click(e => {
            e.preventDefault();

            if (!this.validateForm())
                return;

            var request = this.getSaveEntity();

            serviceCall({
                url: resolveUrl('~/Account/Login'),
                request: request,
                onSuccess: () => {
                    this.redirectToReturnUrl();
                },
                onError: (response: ServiceResponse) => {
                    if (response != null && response.Error != null && response.Error.Code == "TwoFactorAuthenticationRequired") {
                        var args = response.Error.Arguments.split('|');
                        this.handleTwoFactorAuthentication(request.Username, request.Password, args[1], args[0]);
                        return;
                    }

                    if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                        window.location.href = response.Error.Arguments;
                        return;
                    }

                    if (response != null && response.Error != null && !isEmptyOrNull(response.Error.Message)) {
                        notifyError(response.Error.Message);
                        $('#Password').focus();

                        return;
                    }

                    ErrorHandling.showServiceError(response.Error);
                }
            });
        });
    }

    protected redirectToReturnUrl() {
        var q = parseQueryString();
        var returnUrl = q['returnUrl'] || q['ReturnUrl'];
        if (returnUrl) {
            var hash = window.location.hash;
            if (hash != null && hash != '#')
                returnUrl += hash;
            window.location.href = returnUrl;
        }
        else {
            window.location.href = resolveUrl('~/');
        }
    }

    protected handleTwoFactorAuthentication(user: string, pass: string, twoFactorGuid: string, info: string) {
        var tries = 0;
        var remaining = 120;

        var dialog = null;

        var showDialog = () => {
            dialog = new PromptDialog({
                title: "Two Factor Authentication",
                editorOptions: {
                    maxLength: 4,
                },
                editorType: "Integer",
                message: info,
                isHtml: true,
                required: true,
                validateValue: (x) => {
                    if (x >= 1000 && x <= 9999) {
                        tries++;

                        serviceCall({
                            url: resolveUrl('~/Account/Login'),
                            request: {
                                Username: user,
                                Password: pass,
                                TwoFactorGuid: twoFactorGuid,
                                TwoFactorCode: x
                            },
                            onSuccess: () => {
                                this.redirectToReturnUrl();
                                return;
                            },
                            onError: (z: ServiceResponse) => {
                                notifyError(z.Error.Message);

                                if (tries > 2) {
                                    notifyError("Code entered is invalid! You can't try more than 3 times!");
                                    dialog = null;
                                    return;
                                }

                                showDialog();
                            }
                        });

                        return true;
                    }

                    notifyError("Please enter a valid code!");
                    return false;
                }
            });

            dialog.dialogOpen();
            dialog.element.on("dialogclose.me", function (x) {
                if (dialog != null) {
                    dialog.element.off("dialogclose.me");
                    dialog = null;
                }
            });
        };

        function updateCounter() {
            remaining -= 1;
            if (dialog != null) {
                dialog.element.find("span.counter").text(remaining.toString());
            }

            if (remaining >= 0)
                setTimeout(updateCounter, 1000);
            else if (dialog != null)
                dialog.dialogClose();
        };

        showDialog();
        window.setTimeout(updateCounter, 1000);
    }

    protected getTemplate() {
        return `
<h2 class="text-center p-4">
    <img src="${resolveUrl("~/Content/site/images/serenity-logo-w-128.png")}"
        class="rounded-circle p-1" style="background-color: var(--s-sidebar-band-bg)"
        width="50" height="50" /> CsiWebPortal
</h2>

<div class="s-Panel p-4">
    <h5 class="text-center my-4">${htmlEncode(Texts.Forms.Membership.Login.LoginToYourAccount)}</h5>
    <form id="~_Form" action="">
        <div id="~_PropertyGrid"></div>
 
        <div class="px-field">
            <button id="~_LoginButton" type="submit" class="btn btn-primary my-3 w-100">
                ${htmlEncode(Texts.Forms.Membership.Login.SignInButton)}
            </button>
        </div>
    </form>
</div>

  
`;
    }
}